import { useTranslation } from 'next-i18next';
import { availableSocialMedias, SocialMediaComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSetting, PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface SocialMediaSettingsTableInterface {
  component: SocialMediaComponentInterface;
  onChange: (c: SocialMediaComponentInterface) => void;
}

const SocialMediaSettingsTable = ({ component, onChange }: SocialMediaSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  function getOptions(onlySelected = false) {
    return Object.keys(availableSocialMedias)
      ?.filter((key) => !onlySelected || component.socialMedias?.includes(key))
      .map((key) => ({
        name: availableSocialMedias[key],
        value: key,
        urlPlaceholder: key === 'website' ? 'https://www.website.com' : key === 'xtwitter' ? 'https://x.com/username' : `https://${key}.com/username`,
      }));
  }

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'socialMedias',
          type: 'multiselect',
          label: t('pagebuilder:socialmedia'),
          options: getOptions(),
          selectedOptions: getOptions(true),
        },
        ...getOptions(true).map((option) => ({
          path: `socialMediaLinks.${option.value}`,
          type: 'text' as PageBuilderSetting['type'],

          label: option.name + '-URL',
          textFieldProps: {
            key: option.value,
            placeholder: option.urlPlaceholder,
          },
        })),
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default SocialMediaSettingsTable;
